import script from "./ChecklistsMainContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistsMainContent.vue?vue&type=script&setup=true&lang=ts"

import "./ChecklistsMainContent.vue?vue&type=style&index=0&id=34543016&scoped=true&lang=css"

import exportComponent from "/app/tmp/rd/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34543016"]])

export default __exports__